
/** 
* This file has been auto-generated by '@kontent-ai/model-generator@8.1.1'.
* 
* (c) Kontent.ai
*  
* -------------------------------------------------------------------------------
* 
* Project: UnumUK Employer Portal
* Environment: Dev (Previously Phase 2)
* Id: a5beabf7-cb3f-0126-9900-a0a631d69346
* 
* -------------------------------------------------------------------------------
**/

import type { Elements } from '@kontent-ai/delivery-sdk';
import type { CoreContentType } from "../system/index.js";
import type {
  NavInternalLink,
  NavExternalLink,
  MediaAsset,
  MediaExternalVideo,
} from "./index.js";
import type { Products } from "../taxonomies/index.js";

/**
 * 🏗️ Component // Accordion
 *
 * Id: bb1692dc-ee6e-4bd7-a317-e57202d82bc3
 * Codename: accordion
 */
export type ComponentAccordion = CoreContentType<
    ComponentAccordionElementCodenames,
    {
        /**
         * Title
         *
         * Type: text
         * Required: true
         * Codename: title
         * Id: 1820a1d1-23c7-466a-8e7e-f81ac2a6ded7
         */
        readonly title: Elements.TextElement;
        /**
         * Subtitle
         *
         * Type: text
         * Required: true
         * Codename: subtitle
         * Id: 76dd46fe-6116-42bd-be9a-8a7867c6b6de
         */
        readonly subtitle: Elements.TextElement;
        /**
         * Body
         *
         * Type: rich_text
         * Required: true
         * Codename: body
         * Id: b17269b5-acf7-4ca2-987f-46590b944ebf
         */
        readonly body: Elements.RichTextElement<NavInternalLink | NavExternalLink>;
        /**
         * Asset
         *
         * Type: modular_content
         * Required: false
         * Codename: asset
         * Id: 03e67133-ce47-49ca-b20c-338ca10eec76
         */
        readonly asset: Elements.LinkedItemsElement<MediaAsset | MediaExternalVideo>;
        /**
         * CTAs
         *
         * Type: modular_content
         * Required: false
         * Codename: ctas
         * Id: a8858576-8b29-4f48-9bc8-caa3fa00c4c8
         */
        readonly ctas: Elements.LinkedItemsElement<NavInternalLink | NavExternalLink>;
        /**
         * Products
         *
         * Type: taxonomy
         * Required: false
         * Codename: products
         * Id: 58e80932-5be6-4f27-bd53-2d38eaa1a77d
         * Guidelines: • Restrict the visibility of this content to selected products. • If no products are selected, the content will be visible to all users.
         */
        readonly products: Elements.TaxonomyElement<Products, 'products'>;
    },
    'accordion'
>;

/**
 * Type representing all available element codenames for 🏗️ Component // Accordion
 */
export type ComponentAccordionElementCodenames = 'title' | 'subtitle' | 'body' | 'asset' | 'ctas' | 'products';

/**
 * Type guard for 🏗️ Component // Accordion
 *
 * Id: bb1692dc-ee6e-4bd7-a317-e57202d82bc3
 * Codename: accordion
 */
export function isComponentAccordion(item: CoreContentType | undefined | null): item is ComponentAccordion {
    return item?.system?.type === 'accordion';
}
